import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import SKZConstants from 'SKZConstants';

import {
  StyleSheet,
} from 'react-native';

const {
  fontRegular,
  fontSecondary,
  fontSizeH3,
  fontSizeH4,
  viewCornerRadiusSecondary,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  overlayContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },

  bodyMargins: {
    marginBottom: 15,
    marginHorizontal: 25,
    marginTop: 20,
  },

  bodyText: {
    ...fontSizeH4,
    ...fontRegular,
    color: '#333',
    textAlign: 'center',
  },

  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 30,
    marginTop: 20,
  },

  fullWidthButtonContainer: {
    marginHorizontal: 20,
  },

  buttonLayout: {
    height: 35,
    marginHorizontal: 5,
    width: 120,
  },

  fullWidthButtonLayout: {
    height: 35,
    marginHorizontal: 9,
    flex: 1,
  },

  modalContainer: {
    backgroundColor: '#fff',
    width: Sizes.select({
      phone: '100%',
      tablet: SKZConstants.TABLET_USABLE_AREA_WIDTH_PERCENT,
    }),
  },

  pushButtonText: {
    ...fontSizeH4,
    ...fontSecondary,
    color: '#fff',
  },

  titleMargins: {
    marginTop: 20, // used instead of marginVertical so that..
    marginBottom: 20, // ... these attributes can be overriden
  },

  titleText: {
    ...fontSizeH3,
    ...fontSecondary,
    color: '#333',
    textAlign: 'center',
  },

  cornerRadius: {
    ...viewCornerRadiusSecondary,
  },
});
